<ng-container *ngIf="loading">
  <mapfre-loading></mapfre-loading>
</ng-container>
<ng-container *ngIf="!loading"> 
  <app-imp-notice *ngIf="impNoticeTxt?.length" [impText]="impNoticeTxt"></app-imp-notice> 
  <div class="confirm-width-container">
    <div class="d-flex flex-column align-items-center">
      <figure class="mb-2 unenrolled-pic">
        <ng-container *ngIf="!isAcmic; else acmicCloseIcon">
          <img src="./assets/img/images/icon-check-circle-mapfre.svg" alt="check circle icon" />
      </ng-container>
      <ng-template #acmicCloseIcon>
          <img src="./assets/img/images/icon-check-circle-acmic.svg" alt="check circle icon" />
      </ng-template>     
      </figure>
      <div class="autopay-title title-width">
        Your {{ policy?.displayType?.label | lowercase }} policy 
        {{ policy?.policynumber.policyNumber }} payment information is successfully updated
    </div>
    </div>

    <div class="autopay-sub-title">
      {{ "BILLING_SECTION_AUTOPAY_STATEMENT" | translate }}
    </div>

    <div class="d-flex flex-column align-center w-100-mobile mt-4" [ngClass]="{ 'mt-16-mobile': isAcmic }">
      <mapfre-button 
        additionalClasses="basic primary large-btn text-capitalize"
        (click)="openAutoPay()"
      >
        {{ "Ok" | translate }}
      </mapfre-button>
    </div>
    <!-- <div class="row">
      <div class="col">
        <div class="row notice-content margin-bottom mb24" *ngIf="impNoticeTxt?.length">
          <ng-container *ngIf="isAcmic; else maNotification">
            <app-imp-notice [impText]="impNoticeTxt"></app-imp-notice>
          </ng-container>
          <ng-template #maNotification>
            <div>
              <div class="imp-notice">
                <div class="icon-block">
                  <img src="./assets/img/images/icon-warning-red.svg" alt="warning icon" />
                </div>
                <div class="imp-notice-content text-left">
                  <div class="imp-title mb-1">{{ "IMPORTANT_NOTICE" | translate }}</div>
                  <div class="imp-para">{{ impNoticeTxt }} <b>{{sortedInvoices[0]?.dateDue | date:'MM/dd/yyyy'}}</b>.</div>
                </div>
              </div>
          </div>
          </ng-template>
          
        </div>



        <p class="para margin-bottom mb24 font-bold">
          {{ "Keep an eye out for an updated Autopay statement" | translate }}
        </p>
        <div class="d-flex flex-column">
          <mapfre-button additionalClasses="basic primary large-btn margin-bottom mb24 text-capitalize"
            (click)="openAutoPay()">
            {{ "Continue" | translate }}
          </mapfre-button>
        </div>
      </div>
    </div>   -->
</div>
</ng-container>